import React from 'react'
import { CustomAvatar, ViewAnnouncementCard, ViewAnnouncementCardTop, ViewAnnouncementCardBody } from './view-announcement.style'
import { MdPrint, MdCreate, MdDelete } from "react-icons/md";
import { FaBullhorn } from "react-icons/fa";

const ViewAnnouncement = () => {
    const isTeacher = window.location.pathname.includes('teacher')

    return (
        <ViewAnnouncementCard>
            <ViewAnnouncementCardTop>
                <div className="avatar-and-name">
                    <CustomAvatar alt="Name" src="/assets/images/account-avatar.webp" />
                    <div className="announcement-name-info">
                        <h2 className="announcer-name">Bello Ade</h2>
                        <span className="announcement-time">2 hours ago</span>
                    </div>
                </div>
                <div className="icon-container">
                    {isTeacher ? (
                        <>
                            <MdCreate /> <MdDelete />
                        </>
                    ) : (
                        <MdPrint />
                    )}
                </div>
            </ViewAnnouncementCardTop>
            <ViewAnnouncementCardBody>
                <div className="view-announcement-card-body-top">
                    <div className="icon-container">
                        <FaBullhorn />
                    </div>
                    <div className="announcement-title">
                        <h2>Mathematics</h2>
                    </div>
                </div>
                <div className="view-announcement-card-body-main">
                    <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Sed egestas egestas fringilla phasellus faucibus. Eget sit amet tellus cras adipiscing enim eu turpis egestas. Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque. In nisl nisi scelerisque eu. Arcu risus quis varius quam quisque id. Gravida neque convallis a cras semper auctor neque vitae.
                        Eget aliquet nibh praesent tristique magna. Vulputate mi sit amet mauris commodo quis. Mattis ullamcorper velit sed ullamcorper morbi tincidunt ornare massa. Nulla pharetra diam sit amet nisl. Nec ultrices dui sapien eget mi proin sed libero enim. Congue eu consequat ac felis donec et.

                        Morbi non arcu risus quis varius quam quisque id diam. Et pharetra pharetra massa massa ultricies mi quis. Ultricies leo integer malesuada nunc vel. A diam maecenas sed enim ut sem viverra aliquet. Non blandit massa enim nec. Sollicitudin tempor id eu nisl nunc. Massa id neque aliquam vestibulum morbi blandit cursus. Viverra maecenas accumsan lacus vel facilisis volutpat est velit.
                    </p>
                </div>
            </ViewAnnouncementCardBody>
        </ViewAnnouncementCard>
    )
}

export { ViewAnnouncement }
